import { render, staticRenderFns } from "./EnviarSaidas.vue?vue&type=template&id=5e6f4e64&scoped=true"
import script from "./EnviarSaidas.vue?vue&type=script&lang=js"
export * from "./EnviarSaidas.vue?vue&type=script&lang=js"
import style0 from "./EnviarSaidas.vue?vue&type=style&index=0&id=5e6f4e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6f4e64",
  null
  
)

export default component.exports